<template>
    <div>
        <StepsBar :active-index = "activeIndex"/>
        <StepsHolder @validateFields="validateFields" @setActiveIndex="setActiveIndex" :shop="shop">
            <component 
                :is="`Step${activeIndex+1}`" 
                :data="shop"
                @setData="setShop"
                ref = "activeStep" 
            ></component>
        </StepsHolder>
        <UnsavedChanges
            v-if="hasChanges"
            title="Are you sure you want to leave?"
            text="All your changes will be lost"
            save-text="Stay"
            no-text="Leave"
            @submit="onModalHide"
            @no="onLeave"
            @close="onModalHide"/>
    </div>
</template>

<script>
import StepsBar from './Steps/StepsBar'
import StepsHolder from './Steps/StepsHolder'
import Step1 from './Steps/Step1'
import Step2 from './Steps/Step2'
import Step3 from './Steps/Step3'
import Step4 from './Steps/Step4'
import {useShop, useDisabled, useErrors, useStore, useRouter} from '../../core/hooks'
import { provideErrors } from '../../core/providers'
import {computed, ref, onMounted, onUnmounted, watch} from '@vue/composition-api'
import UnsavedChanges from '../../popups/UnsavedChangesEcommerce'
import useUnsavedOnClose from '../../components/Ecommerce/useUnsavedOnClose'

export default {
    name: 'AddShop',
    components: {
        StepsBar,
        StepsHolder,
        Step1, 
        Step2, 
        Step3, 
        Step4,
        UnsavedChanges
    },
    beforeRouteLeave (to, from , next) {
        if(!this.checkStep()) {
            return next()
        }
        this.checkPage(to, next)
    },
    setup(props, {root}) {
        provideErrors([
            'wrong-shop-url-format',
            'shop-url-not-found',
            'find-shop-internal-error',
            'existing-shop',
            'empty-description',
            'empty-title',
            'missing-logo',
            'missing-cover',
            'no-crossprom-option-selected',
            'missing-subscribers-number',
            'missing-banner-link',
            'missing-blog-page-link',
            'missing-other-description'
            
        ]);

        const {store} = useStore()
        const {router} = useRouter()

        const {shop, setShop} = useShop(null)
        const {setShopChanges} = useUnsavedOnClose(shop.value)
        const hasChanges = ref(false)
        const routeTo = ref(null)

        watch(shop, shop => {
            setShopChanges(shop)
        })

        const activeStep = ref()

        const errors = useErrors().messages;

        const activeIndex = ref(0)

        const setActiveIndex = (val) => {
            activeIndex.value = val
        }

        const validateFields = async () => {
            if(activeIndex.value === 0) {
                return
            }
            return activeStep.value.validateFields()
        }

        const checkStep = () => {
            if(activeIndex.value !== 0 && !shop.value.verified) {
                return true
            }
            return false
        }


        const checkPage = (to, next) => {
            if(routeTo.value) {
                routeTo.value = null
                return next()
            }
            hasChanges.value = true
            routeTo.value = to
        }

        const onLeave = () => {
            root.$sendMixpanelEvent('Left Wizard Without Saving', {
                Step: activeIndex.value + 1,
                Shop: shop.value.title
            })
            root.$ga.event('Add Shop', 'Left Wizard Without Saving', `
                Step: ${activeIndex.value + 1},
                Shop: ${shop.value.title}
            `)
            router.push({ path: routeTo.value.path })
        }

        const onModalHide = () => {
            hasChanges.value = false
            routeTo.value = null
        }

        return {
            shop,
            setShop,
            routeTo,
            hasChanges,
            errors,
            activeIndex,
            setActiveIndex,
            validateFields,
            activeStep,
            checkStep,
            checkPage,
            onModalHide,
            onLeave
        }

    },
    methods: {
        setData(key, value){
            this.shopData = {
                ...this.shopData, 
                [key]:value
            }
        }
    }
}
</script>